
const setCookie = (cname,cvalue,exdays) => {
  var expires = "max-age="+(exdays*24*60*60);
  var cookieStr = cname + "=" + cvalue + "; " + expires + "; path=/";
  document.cookie = cookieStr;
}

const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++)
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}

export default {
  setCookie,
  getCookie
}
